import { NextLink, Translate } from '~/i18n';
import Container from '~/components/common/container';
import style from './style.module.css';
import { useTranslate } from '~/i18n';
import { homepageCategoryBtnEvent } from '~/utils/mixpanel-events/business';
import { isJarir } from '~/utils/theme';

const BusinessType = () => {
   const { locale, translate } = useTranslate();

   const businessTypes = [
      {
         img: 'url("/images/home-page/bg.jpg")',
         name: translate({ id: 'business:tours' }),
         description: translate({ id: 'business:tours sub title' }),
         url: '/business/tours',
      },
      {
         img: 'url("/images/business/type/experiences.png")',
         name: translate({ id: 'common:experiences' }),
         description: translate({ id: 'business:experinces sub title' }),
         url: '/business/experiences',
      },
      {
         img: 'url("/images/business/type/classes.png")',
         name: translate({ id: 'business:classes' }),
         description: translate({ id: 'business:classes sub title' }),
         url: '/business/classes',
      },
      {
         img: 'url("/images/business/type/restaurants.jpg")',
         name: translate({ id: 'business:restaurants title' }),
         description: translate({ id: 'business:restaurants sub title' }),
         url: '/business/restaurants',
      },
      {
         img: 'url("/images/business/type/exhibitions.png")',
         name: translate({ id: 'business:exhibitions title' }),
         description: translate({ id: 'business:exhibitions sub title' }),
         url: '/business/exhibitions',
      },
      {
         img: 'url("/images/business/type/musicians.jpeg")',
         name: translate({ id: 'business:muisicians title' }),
         description: translate({ id: 'business:muisicians sub title' }),
         url: '/business/musicians',
      },
      {
         img: 'url("/images/business/type/gyms.jpeg")',
         name: translate({ id: 'business:gyms title' }),
         description: translate({ id: 'business:gyms sub title' }),
         url: '/business/gym',
      },
      {
         img: 'url("/images/business/type/spa.jpeg")',
         name: translate({ id: 'business:spa title' }),
         description: translate({ id: 'business:spa sub title' }),
         url: '/business/spa',
      },
   ];
   return (
      <div className={`${style['yellow-bg']}`}>
         <Container>
            <div className="text-[30px] lg:text-[50px] pt-[40px] lg:pt-[105px] text-center font-bold text-white">
               <Translate id="business:solutions" />
            </div>
            <div className="grid gap-4 lg:grid-cols-4 py-[37.4px] lg:pt-[95.4px] lg:pb-[125px] lg:h-[706.62px]">
               {businessTypes.map((value, key) => (
                  <div key={key} className="relative">
                     <div
                        className={`bg-center bg-cover lg:bg-cover bg-no-repeat rounded-xl  w-full h-[226px]  relative group ${
                           isJarir ? 'flex items-center' : 'lg:hover:h-[251px] '
                        }`}
                        style={{ backgroundImage: value.img }}>
                        <div className={style['overlay']}></div>
                        <div className="absolute grid w-full p-3 text-white justify-items-center">
                           <div className="flex pt-[10px] pb-[5px]  lg:pb-0">
                              <div className="flex-grow sm:mb-2 ltr:text-[30px] lg:ltr:text-[30px] rtl:text-[30px] lg:rtl:text-[28px] font-semibold lg:font-bold ltr:whitespace-nowrap leading-6 rtl:mb-4 lg:rtl:mb-3">
                                 {value.name}
                              </div>
                           </div>
                           <div className=" text-[14px] sm:text-base text-center  lg:h-[90px] rtl:mb-4 lg:rtl:mb-0">
                              {value.description}
                           </div>
                           {!isJarir &&
                              (value.url ? (
                                 <NextLink href={value.url}>
                                    <button
                                       className="px-2 py-1 mt-8 text-black bg-white rounded-lg lg:hidden lg:group-hover:block "
                                       onClick={() => homepageCategoryBtnEvent(value.name)}>
                                       <Translate id="business:signup now" />
                                    </button>
                                 </NextLink>
                              ) : (
                                 <a href={`https://pro.halayalla.com/${locale}/supplier/login`}>
                                    <button className="px-2 py-1 mt-8 text-black bg-white rounded-lg lg:hidden lg:group-hover:block ">
                                       <Translate id="business:signup now" />
                                    </button>
                                 </a>
                              ))}
                        </div>
                     </div>
                  </div>
               ))}
            </div>
         </Container>
      </div>
   );
};
export default BusinessType;
